// Libraries.
import { scarpaGray100, scarpaGray50, scarpaGray800, spanishViridian500, strokesAAA, white } from '@habitech/shared';
import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    z-index: 3;
    left: 0;
    right: 0;
    position: relative;
    .innerLabel {
        padding-top: 0 !important;
    }
    i svg {
        position: relative;
    }
    svg {
        position: absolute;
        z-index: 1;
        &.close {
            top: 17px;
            right: 48px;
            background: ${white};
            path {
                fill: ${strokesAAA};
            }
        }
    }
    .search .pcom-loading {
        height: 48px;
        svg:nth-child(1) {
            width: 20px;
            height: 20px;
        }
        .pcom-circle {
            stroke: ${white};
        }
    }
`;

export const IconSearch = styled.div`
    border-radius: 0 6px 6px 0;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 40px;
    height: 48px;
    background: ${spanishViridian500};
    z-index: 1;
    svg {
        top: 14px;
        right: 10px;
        path {
            fill: ${white};
        }
    }
    &:hover {
        cursor: pointer;
    }
`;

export const List = styled.ul`
    position: relative;
    width: 100%;
    height: auto;
    max-height: 280px;
    overflow: auto;
    background: ${white};
    box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.1);
    border-radius: 0 0 8px 8px;
    margin: 3px 0;
    padding: 0;
`;

export const ListItem = styled.li`
    border-bottom: 1px solid ${scarpaGray100};
    height: 56px;
    font-weight: 400;
    font-size: 16px;
    line-height: 56px;
    color: ${scarpaGray800};
    padding: 0 16px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    &:active {
        background: ${scarpaGray50};
    }
    &:hover {
        cursor: pointer;
        background: ${scarpaGray50};
    }
`;

export const Blockquote = styled.div`
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    background-color: transparent;
`;
